<template>
  <div>
    <Header></Header>
    <div class="page-container">
      <router-view />
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from './header'
import Footer from './footer.vue'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {}
  }
}
</script>